import React from "react";
import Navb from "../../../../components/navbar/Navb";
import Footer from "../../../../components/footer/Footer";
import RecipiePage from "../../../../components/recipiePage/RecipiePage";
import Recpiesimg1 from "./recpiesimg1.png";
import Recpiesimg2 from "./recpiesimg2.png";
import Recpiesimg3 from "../../img2.png";
import Recpiesimg4 from "../../img3.png";
import Recpiesimg5 from "../../img14.png";
import Img1 from "./img1.png";
import Timer from "../timer.png";
import "../recipe.css";
const Sojivegcheela = () => {
  return (
    <>
      <RecipiePage
        Recpiesimg1={Recpiesimg1}
        Recpiesimg2={Recpiesimg2}
        Recpiesimg3={Recpiesimg3}
        Recpiesimg4={Recpiesimg4}
        Recpiesimg5={Recpiesimg5}
        Img1={Img1}
        Name="Sooji Veg Cheela"
        Ul1={
          <ul>
            <li>
              <span className="Bold">Nandi sooji (semolina)</span>
            </li>
            <li>yogurt</li>
            <li>Water</li>
            <li>finely chopped onions </li>
            <li>grated carrots</li>
            <li>chopped bell peppers (mixed colors)</li>
          </ul>
        }
        Ul2={
          <ul className="noDecoration">
            <li>1 cup</li>
            <li>1/2 cup</li>
            <li>1/2 cup</li>
            <li>1/2 cup</li>
            <li>1/2 cup</li>
            <li>1/2 cup</li>
          </ul>
        }
        Ul3={
          <ul>
            <li>finely chopped coriander leaves</li>
            <li>ginger-garlic paste</li>
            <li>green chili, finely chopped</li>
            <li>Salt</li>
            <li>cumin seeds</li>
            <li>Oil or ghee</li>
          </ul>
        }
        Ul4={
          <ul className="noDecoration">
            <li>2 tablespoons</li>
            <li>1 tablespoon</li>
            <li>1 piece </li>
            <li> to taste</li>
            <li>1/2 teaspoon</li>
            <li>for cooking</li>
          </ul>
        }
        Ol1={
          <ol>
            <li>
              In a mixing bowl, combine sooji, yogurt, and water. Mix well and
              let it rest for 15-20 minutes to allow the sooji to absorb the
              liquids.
            </li>

            <li>
              Add finely chopped onions, grated carrots, chopped bell peppers,
              coriander leaves, ginger-garlic paste, green chili, salt, cumin
              seeds, and baking soda (if using) to the batter. Mix everything
              well to form a thick batter.
            </li>

            <li>
              Heat a non-stick pan or griddle over medium heat. Grease it
              lightly with oil or ghee.
            </li>
            <li>
              Pour a ladleful of the batter onto the hot pan and spread it into
              a round shape, similar to a pancake.
            </li>

            <li>
              Cook until the edges start to lift and the bottom turns golden
              brown. Drizzle a little oil or ghee around the edges
            </li>

            <li>
              Flip the cheela and cook the other side until it becomes golden
              brown and cooked through.
            </li>

            <li>Repeat the process for the remaining batter.</li>
            <li>
              Serve the Sooji and Vegetable Cheela hot with your favorite
              chutney or yogurt.
            </li>
          </ol>
        }
        Item1="Mix Veg Paratha"
        Item2="Whole Atta Cookies"
        Item3="Atta Momos"
        Link1="mixvegparatha"
        Link2="wholeattacookies"
        Link3="wholeattavegmomos"
      />
      {/* <Navb />
      <div className="singleRecipeTop">Sooji Veg Cheela</div>
      <img className="singleRecipeTopimg" src={Recpiesimg1} alt="Recpiesimg1" />
      <div className="singleRecipeBot">
        <div className="singleRecipeBotLeftItems">
          <div className="singleRecipeBotLeftItemTitle">INGREDIENTS</div>
          <hr />
          <div className="singleRecipeBotLeftItem">
            <ol>
              <li>
                1 cup <span className="Bold">Nandi sooji (semolina)</span>
              </li>
              <li>1/2 cup yogurt</li>
              <li>1/2 cup water</li>
              <li>1/2 cup finely chopped onions</li>
              <li>1/2 cup grated carrots</li>
              <li>1/2 cup chopped bell peppers (mixed colors)</li>
              <li>2 tablespoons finely chopped coriander leaves</li>
              <li>1 teaspoon ginger-garlic paste</li>
              <li>1 green chili, finely chopped</li>
              <li>Salt to taste</li>
              <li>1/2 teaspoon cumin seeds</li>
              <li>1/2 teaspoon baking soda (optional)</li>
              <li>Oil or ghee for cooking</li>
            </ol>
          </div>
          <hr />
          <div className="flexitemrecipe">
            <img src={Recpiesimg2} alt="Recpiesimg2" />
            Nandi Besan
          </div>
        </div>
        <div className="singleRecipeBotRight">
          <div className="singleRecipeBotRightTop">Instructions</div>
          <ol>
            <li>
              Prepare the Batter:
              <ul>
                <li>
                  In a mixing bowl, combine sooji, yogurt, and water. Mix well
                  and let it rest for 15-20 minutes to allow the sooji to absorb
                  the liquids.
                </li>
              </ul>
            </li>
            <li>
              Vegetable Mix:
              <ul>
                <li>
                  Add finely chopped onions, grated carrots, chopped bell
                  peppers, coriander leaves, ginger-garlic paste, green chili,
                  salt, cumin seeds, and baking soda (if using) to the batter.
                  Mix everything well to form a thick batter.
                </li>
              </ul>
            </li>
            <li>
              Cooking Cheela:
              <ul>
                <li>
                  Heat a non-stick pan or griddle over medium heat. Grease it
                  lightly with oil or ghee.
                </li>
                <li>
                  Pour a ladleful of the batter onto the hot pan and spread it
                  into a round shape, similar to a pancake.
                </li>
              </ul>
            </li>
            <li>
              Cooking Both Sides:
              <ul>
                <li>
                  Cook until the edges start to lift and the bottom turns golden
                  brown. Drizzle a little oil or ghee around the edges
                </li>
              </ul>
            </li>
            <li>
              Flip and Cook:
              <ul>
                <li>
                  Flip the cheela and cook the other side until it becomes
                  golden brown and cooked through.
                </li>
              </ul>
            </li>
            <li>
              Serve Hot:
              <ul>
                <li>Repeat the process for the remaining batter.</li>
                <li>
                  Serve the Sooji and Vegetable Cheela hot with your favorite
                  chutney or yogurt.
                </li>
              </ul>
            </li>
          </ol>
        </div>
      </div>
      <div className="singleRecipeEnd">
        <div className="singleRecipeEndTitle">You Might Also Like</div>
        <div className="singleRecipeEndItems">
          <div className="singleRecipeEndItem">
            <div className="singleRecipeEndItemTop">
              <a href="/recipes/daliakhichadi">
                <img src={Recpiesimg3} alt="Recpiesimg3" />
                <div className="singleRecipeEndItemTitle">Dalia Khichadi</div>
              </a>
            </div>
            <div>
              <img src={Timer} alt="Timer" />
              <span>Ready in 20 mins</span>
            </div>
          </div>
          <div className="singleRecipeEndItem">
            <div className="singleRecipeEndItemTop">
              <a href="/recipes/wholeattacookies">
                <img src={Recpiesimg4} alt="Recpiesimg4" />
                <div className="singleRecipeEndItemTitle">
                  Whole Atta Cookies
                </div>
              </a>
            </div>
            <div>
              <img src={Timer} alt="Timer" />
              <span>Ready in 50 mins</span>
            </div>
          </div>
          <div className="singleRecipeEndItem">
            <div className="singleRecipeEndItemTop">
              <a href="/recipes/besanburfi">
                <img src={Recpiesimg5} alt="Recpiesimg5" />
                <div className="singleRecipeEndItemTitle">Besan burfi</div>
              </a>
            </div>
            <div>
              <img src={Timer} alt="Timer" />
              <span>Ready in 600 mins</span>
            </div>
          </div>
        </div>
      </div>
      <Footer /> */}
    </>
  );
};

export default Sojivegcheela;
